import React, { useEffect, useState } from 'react';

import { RouteSetup } from '@C/Registration';

const LoginPage = () => {
  return (
    <main className="auth-pages">
      <div className="wave-container --top"></div>
      <section className="auth-page">
        <div className="wrapper">
          <RouteSetup />
        </div>
      </section>
      <div className="wave-container --bottom"></div>
    </main>
  );
};

export { LoginPage };
